import React from 'react';
import Box from '@material-ui/core/Box';
export default function about() {
  return (
    <div style={{ width: '75%' }}>
      <h1>How dappr works:</h1>
      <Box p={1}>
        <p>
          dappr is a decentralized dating app. Think Tinder, but on the chain.
          The app checks for a metamask profile, if none is found, it prompts
          the user to make a fortmatic account. Then the user is logged into
          3box.
        </p>
      </Box>
      <Box p={1}>
        <p>
          Users match with others through swiping on profiles, they then can
          communicate with each other using a thread for 3 box chat. If the
          match wants to meet somewhere, both users will be prompted to stake
          $20 worth of Eth. If both stake then they will get their money back
          when they meet each other and scan the QR code on their respective
          phones. If one of them ghosts the meetup they lose the stake.
        </p>
      </Box>
    </div>
  );
}
